import FilterRowView from '@/components/Filtersv2/RowView';
import React from 'react';

import { FilterRowProps } from './interfaces';
import { Container, Content } from './styles';

const FilterRow: React.FC<FilterRowProps> = ({
  screen,
  initialFilters,
  onSubmit,
  getFormattedFilter,
}) => {
  return (
    <>
      <Container>
        <Content>
          <FilterRowView
            screen={screen}
            initialFilters={initialFilters}
            onSubmit={onSubmit}
            getFormattedFilter={getFormattedFilter}
          />
        </Content>
      </Container>
    </>
  );
};

export default FilterRow;
